<template>
  <div class="col-l-6 col-m-12">
    <div class="tile">
      <div class="tile-box">
        <div class="row" style="height: 46px;">
          <!-- TSPC-1874 -->
          <div v-if="price.promotion && texts.cataloguePromotionDisruptorText" class="disruptor"><p v-html="texts.cataloguePromotionDisruptorText"></p></div>
          <div v-else-if="texts.catalogueRegularDisruptorText" class="disruptor"><p v-html="texts.catalogueRegularDisruptorText"></p></div>
          <div class="col-l-12">
            <h4 class="thin underline" style="margin-top: 12px;" v-html="texts.productName"><!-- #D36 --></h4>
            <div v-if="currentInstances || orderedInstances" style="float: right; height: 0;">
              <div style="position: relative; top: -12px">
                <!-- #S95 -->
                <span v-if="orderedInstances > 0" class="badge badge-function">{{ $t('substore.order_in_progress') }}</span>
                <span v-else-if="reservedInstances > 0" class="badge badge-function">{{ $t('substore.reserved') }}</span>
                <span v-else-if="currentInstances === 1 && maxInstances === 1" class="badge badge-dark">{{ $t('substore.already_purchased') }}</span>
                <span v-else-if="currentInstances > 1 && maxInstances === currentInstances" class="badge badge-dark">{{
                  $t('substore.already_purchased_several_times')
                }}</span>
                <span v-else-if="currentInstances > 0 && maxInstances > currentInstances" class="badge badge-dark">{{
                  $tc('substore.purchased_x_times', currentInstances)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-l-4 col-s-12 offset-top-2 offset-bottom-1 pull-right">
            <div v-if="images.productLogoCatalogueResourcePath" class="h-ctr">
              <!-- #D42 -->
              <img :src="'delegates/product/content/' + images.productLogoCatalogueResourcePath" :alt="images.productLogoCatalogueAlt" class="product-image" />
            </div>
          </div>
          <div class="col-l-8 col-s-12 offset-top-1 offset-bottom-1">
            <p v-once v-html="texts.productDescriptionCatalogue"><!-- #D38 --></p>
          </div>
        </div>
        <div class="tile-row">
          <div class="tile-cell">
            <div class="col-l-8 col-s-12 center-text-s" style="margin-top: 16px">
              <!-- #D39 -->
              <VPrice
                :promotion-processing="promotionProcessing"
                :override-text-regular="texts.regularPriceOverrideText"
                :override-text-promotion="texts.promotionPriceOverrideText"
                :price="price"
                :subscription-type="subscriptionType"
              />
            </div>
            <div class="col-l-4 col-s-12 offset-top-1">
              <!-- S98 / #D43 / #I56 -->
              <router-link v-if="isAvailable" class="btn btn-default btn-brand h-ctr" :to="{ name: PRODUCT_DETAILS, params: { subscriptionTemplateId } }">
                <template v-if="texts.catalogueDetailsButtonLabel">
                  {{ texts.catalogueDetailsButtonLabel }}
                </template>
                <template v-else>
                  {{ $t('substore.details') }}
                </template>
              </router-link>
              <img v-else-if="hasUndefinedAvailability" src="@/assets/images/loader.gif" class="pull-right" alt="" />
              <div v-else-if="hasNoneAvailability" class="pull-right">
                {{ $t('substore.product_unavailable') }}
              </div>
              <div v-else-if="failedVerification" class="pull-right">
                {{ $t('substore.product_not_verified') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VPrice from '@/components/Substore/Price';
import SubstoreProductAvailabilityProxy from '@/proxies/SubstoreProductAvailabilityProxy';
import { PRODUCT_DETAILS } from '@route-types';

export default {
  name: 'Product',

  components: {
    VPrice,
  },

  inheritAttrs: false,

  props: {
    subscriptionTemplateId: {
      type: String,
      required: true,
    },

    texts: {
      type: Object,
      required: true,
    },

    images: {
      type: Object,
      required: true,
    },

    price: {
      type: Object,
      required: true,
    },

    promotionProcessing: {
      type: Boolean,
      required: true,
    },

    productAvailability: {
      type: String,
      required: false,
      default: null,
    },

    currentInstances: {
      type: Number,
      required: false,
      default: null,
    },

    orderedInstances: {
      type: Number,
      required: false,
      default: null,
    },

    reservedInstances: {
      type: Number,
      required: false,
      default: null,
    },

    maxInstances: {
      type: Number,
      required: false,
      default: null,
    },

    subscriptionType: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      availability: this.productAvailability,
      PRODUCT_DETAILS,
    };
  },

  computed: {
    hasUndefinedAvailability() {
      return this.availability === 'undefinedAvailability';
    },

    hasNoneAvailability() {
      return this.availability === 'noneAvailability';
    },

    failedVerification() {
      return this.availability === 'verifyingFailed';
    },

    isAvailable() {
      return !(this.hasUndefinedAvailability || this.hasNoneAvailability || this.failedVerification);
    },
  },

  async created() {
    try {
      if (this.productAvailability === 'undefinedAvailability') {
        const response = await new SubstoreProductAvailabilityProxy().find(this.subscriptionTemplateId);
        this.availability = response.data.productAvailability;
        if (response.head.fault !== null) throw new Error(response.head.fault);
      }
    } catch (error) {
      this.availability = 'verifyingFailed';
    }
  },
};
</script>
